//
//
//
//


var script = {
  name: 'ImagixHtmlTransformer',
  props: {
    html: {
      default: null,
      type: String
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      transformedHtml: ''
    };
  },
  created() {
    if (this.html) {
      this.transformHtml();
    }
  },
  methods: {
    transformHtml() {
      this.transformedHtml = this.transformImgixUrlsInHtml(this.html, this.options);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.html ? _c("div", { domProps: { innerHTML: _vm._s(_vm.transformedHtml) } }) : _vm._e();
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* component normalizer */
function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

  // For security concerns, we use only base name in production mode.
  component.__file = "/Users/emily.wu/Desktop/project/repos/vue-imgix-transformer/src/components/ImagixHtmlTransformer.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;

    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */

var ImagixHtmlTransformer = __vue_normalize__({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//

var script$1 = {
  name: 'ImgixImage',
  props: {
    src: {
      default: '',
      type: String
    },
    srcOptions: {
      default() {
        return {};
      },
      type: Object
    },
    dataSrcOptions: {
      default() {
        return {};
      },
      type: Object
    },
    dataSrcset: {
      default() {
        return [{
          options: {},
          width: ''
        }];
      },
      type: Array
    },
    dataSizes: {
      default() {
        return ['auto'];
      },
      type: Array
    },
    alt: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    id: {
      default: null,
      type: String
    },
    config: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      transformedSrc: '',
      transformedDataSrc: {},
      transformedDataSrcset: [],
      transformedDataSizes: []
    };
  },
  created() {
    this.transformData();
  },
  methods: {
    transformData() {
      const srcOptions = this.config ? this.config.srcOptions : this.srcOptions;
      const dataSrcOptions = this.config ? this.config.dataSrcOptions : this.dataSrcOptions;
      const dataSrcset = this.config ? this.config.dataSrcset : this.dataSrcset;
      const dataSizes = this.config ? this.config.dataSizes : this.dataSizes;

      this.transformedSrc = this.transformImgixUrl(this.src, srcOptions);
      this.transformedDataSrc = this.transformImgixUrl(this.src, dataSrcOptions);
      this.transformedDataSrcset = dataSrcset.map(item => {
        const { options, width } = item;
        const transformedUrl = this.transformImgixUrl(this.src, options);

        return `${transformedUrl} ${width}`;
      }).join(', ');
      this.transformedDataSizes = dataSizes.join(', ');
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("img", {
    staticClass: "lazyload",
    attrs: {
      src: _vm.transformedSrc,
      srcset: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      "data-src": _vm.transformedDataSrc,
      "data-srcset": _vm.transformedDataSrcset,
      "data-sizes": _vm.transformedDataSizes,
      alt: _vm.alt,
      title: _vm.title,
      id: _vm.id
    }
  });
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

/* style */
const __vue_inject_styles__$1 = undefined;
/* scoped */
const __vue_scope_id__$1 = undefined;
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* component normalizer */
function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};

  // For security concerns, we use only base name in production mode.
  component.__file = "/Users/emily.wu/Desktop/project/repos/vue-imgix-transformer/src/components/ImgixImage.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;

    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */

var ImgixImage = __vue_normalize__$1({ render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 }, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, undefined, undefined);

const DEFAULTS = {
  domains: []
};

class ImgixClient {
  constructor(options) {
    let key, val;

    this.settings = {};

    for (key in DEFAULTS) {
      val = DEFAULTS[key];
      this.settings[key] = val;
    }

    for (key in options) {
      val = options[key];
      this.settings[key] = val;
    }

    if (!Array.isArray(this.settings.domains)) {
      this.settings.domains = [this.settings.domains];
    }

    if (!this.settings.host && this.settings.domains.length === 0) {
      throw new Error('ImgixClient must be passed valid domain(s)');
    }
  }

  buildURL(path, params) {
    path = this._sanitizePath(path);

    if (params == null) {
      params = {};
    }

    let queryParams = this._buildParams(params);

    return `https://${this._getDomain()}${path}${queryParams}`;
  }

  _getDomain() {
    return this.settings.domains[0];
  }

  _sanitizePath(path) {
    path = path.replace(/^\//, '');

    if (/^https?:\/\//.test(path)) {
      path = encodeURIComponent(path);
    } else {
      path = encodeURI(path);
    }

    return '/' + path;
  }

  _buildParams(params) {
    let queryParams = [];
    let key, val, encodedKey, encodedVal;

    for (key in params) {
      val = params[key];
      encodedKey = encodeURIComponent(key);
      encodedVal = encodeURIComponent(val);

      queryParams.push(encodedKey + "=" + encodedVal);
    }

    if (queryParams[0]) {
      queryParams[0] = "?" + queryParams[0];
    }

    return queryParams.join('&');
  }
}

const absolutePathReg = /^https?/;
const imgElementSearchReg = /(<img[^>]+>)/gi;

class ImgixTransformer {
  constructor(imgixCdnConfigs, imgixModule = ImgixClient) {
    this.imgixCdnConfigs = imgixCdnConfigs;
    this.imgixModule = imgixModule;
    this.clients = this.getClients(imgixCdnConfigs);
  }

  getClients(configs) {
    let clients = {};

    for (let configName in configs) {
      let { cdnOptions } = configs[configName];
      clients[configName] = new this.imgixModule(cdnOptions);
    }

    return clients;
  }

  getClient(configName) {
    if ('undefined' !== typeof configName) {
      return this.clients[configName];
    }

    for (let name in this.imgixCdnConfigs) {
      return this.clients[name];
    }
  }

  getConfigName(url) {
    let cdnConfigs = this.imgixCdnConfigs;
    return Object.keys(cdnConfigs).filter(key => {
      return url.indexOf(cdnConfigs[key].sourceDomain) > -1;
    })[0];
  }

  transformUrl(originalUrl, options) {
    let configName = this.getConfigName(originalUrl);
    let imagePath = originalUrl;

    if (absolutePathReg.test(originalUrl)) {
      if ('undefined' === typeof configName) {
        return originalUrl;
      }

      let { sourceDomain } = this.imgixCdnConfigs[configName];
      imagePath = originalUrl.split(sourceDomain).pop();
    }

    return decodeURIComponent(this.getClient(configName).buildURL(imagePath, options));
  }

  /* deprecated */
  generateImageElement(originalUrl, options) {
    let imgElement = document.createElement('img');
    let url = this.transformUrl(originalUrl, options);
    imgElement.setAttribute('src', url);

    return imgElement;
  }

  transformHtml(originalHtml, options) {
    if ('undefined' === typeof document) {
      return;
    }

    const replacer = match => {
      const wrapperEl = document.createElement('div');
      wrapperEl.innerHTML = match;
      const imagePath = wrapperEl.firstChild.getAttribute('src');
      wrapperEl.firstChild.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      wrapperEl.firstChild.dataset.src = this.transformUrl(imagePath, options);
      wrapperEl.firstChild.classList.add('lazyload');

      return wrapperEl.innerHTML;
    };

    return originalHtml.replace(imgElementSearchReg, replacer);
  }
}

const plugin = {
  install(Vue, options = {}) {
    const { imgixImageConfigs, imgixCdnConfigs, imgixModule } = options;
    const imgixTransformer = new ImgixTransformer(imgixCdnConfigs, imgixModule);

    Vue.prototype.$imgixTransformer = imgixTransformer;

    Vue.component(ImagixHtmlTransformer.name, ImagixHtmlTransformer);
    Vue.component(ImgixImage.name, ImgixImage);

    Vue.filter('imgixTransformUrl', (url, opts) => {
      return imgixTransformer.transformUrl(url, opts);
    });

    Vue.mixin({
      data() {
        return {
          imgixImageConfigs
        };
      },
      methods: {
        transformImgixUrl(url, options) {
          return imgixTransformer.transformUrl(url, options);
        },
        transformImgixUrlsInHtml(html, options) {
          return imgixTransformer.transformHtml(html, options);
        }
      }
    });
  }
};

export default plugin;
